import React, {useEffect} from "react";
import { HashRouter, Switch, Route } from 'react-router-dom';
import { useSetRecoilState } from "recoil";

import { isMobileAtom } from 'store/atoms';
import { size } from "theme/breakpoints"
import config from 'config/config.json';

import Version from 'utils/version';
import TommyMain from 'components/TommyMain';
import AnalyticsHandler from "components/Analytics";
import TommyTeaser from 'components/TommyTeaser';
import styles from './App.module.scss';
const {showTeaser} = config;

function App() {

  const setIsMobile = useSetRecoilState(isMobileAtom);

  useEffect(() => {
    const mobileMediaQuery = () => window.matchMedia(`(max-width: ${size.sm}px), (orientation: portrait)`);
    if (matchMedia) {
      mobileMediaQuery().addListener((e) => {
        setIsMobile(e.matches)
      })
    }
  }, []);

  Version()
  return (
    <div className={styles.App}>
      <HashRouter>
        <AnalyticsHandler />
        <Switch>
          <Route exact path="/">
            {showTeaser ? <TommyTeaser /> : <TommyMain/>}
          </Route>
          <Route exact path="/nft">
            {showTeaser ? <TommyTeaser /> : <TommyMain/>}
          </Route>
          <Route path="/teaser">
            <TommyTeaser />
          </Route>
          <Route path="/teaser/nft">
            <TommyTeaser />
          </Route>
        </Switch>
      </HashRouter>
    </div>
  );
}

export default App;
